import v1 from 'src/api/v1'

export const APIv1 = v1
